<template>
  <div
    v-if="
      field !== 'templateName' &&
      field !== 'clientId' &&
      field !== 'configLabel'
    "
    class="field"
    :class="[
      hasValue({
        field,
        category,
      }) && 'has-value',
      bulkDelete ? 'bulk-delete' : 'bulk-edit',
    ]"
  >
    <div class="question" :id="id">
      <bulkDeleteCheckbox v-if="bulkDelete" :fields="getBulkDeleteFields" />
      <p v-if="field === 'logo'">Logo</p>
    </div>
    <div class="answer" v-if="!bulkDelete">
      <logo
        v-if="field === 'logo'"
        :id="bulkDelete ? 'bulkDelete' : 'bulkEdit'"
        :category="category"
      />
    </div>
  </div>
</template>
    
<script>
/**
 * @fileoverview Bulk update custom fields handler
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";

import logo from "@/components/config-tab/custom-fields/logo";

import bulkDeleteCheckbox from "./bulk-delete-checkbox";

import getFieldData from "@/util/getFieldData";

export default {
  name: "CustomFields",
  components: {
    bulkDeleteCheckbox,
    logo,
  },
  props: {
    id: {
      type: String,
    },
    category: {
      type: String,
    },
    field: {
      type: String,
    },
    bulkDelete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getBulkDeleteFields() {
      switch (this.field) {
        case "logo":
          return [
            {
              id: "FileName",
              category: this.category,
              parentField: undefined,
              type: "string",
            },
            {
              id: "FileSource",
              category: this.category,
              parentField: undefined,
              type: "string",
            },
            {
              id: "FileType",
              category: this.category,
              parentField: undefined,
              type: "string",
            },
          ];
      }
      return [];
    },
    ...mapGetters({
      updatedValues: "getUpdatedConfigValues",
      configTemplate: "getConfigTemplate",
    }),
  },
  methods: {
    fieldList(category = this.category) {
      const fieldData = this.configTemplate && this.configTemplate[category];
      return fieldData && fieldData.AvailableFieldList;
    },
    hasValue({ field, category }) {
      return typeof this.getConfigValue({ field, category }) !== "undefined";
    },
    getConfigValue({ field, category = this.category }) {
      const clientId = this.bulkDelete ? "bulkDelete" : "bulkEdit";
      const idMapping = {
        logo: "FileName",
      };
      const id = idMapping[field];
      if (!id) return null;
      return (
        this.updatedValues[clientId] &&
        this.updatedValues[clientId][category] &&
        this.updatedValues[clientId][category][id]
      );
    },
    getFieldData({ id, category }) {
      return getFieldData(this.fieldList(category), id);
    },
  },
};
</script>
    
<style lang="scss" scoped>
.field {
  display: grid;
  align-items: flex-start;
  grid-template-columns: 1fr 1fr;
  min-height: 81px;
  gap: 36px;
  &.bulk-delete {
    align-items: center;
  }

  .question {
    display: flex;
    align-items: flex-start;
    gap: $qvo-spacing-8;
    padding: 20px 0 20px $qvo-spacing-16;
    &::v-deep {
      .v-icon {
        top: -1px;
      }
    }
  }
  .answer {
    padding: 20px $qvo-spacing-16 20px 0;
  }
  &::v-deep {
    .config-field {
      margin-bottom: 0;
    }
  }
}
.content-group {
  padding: $qvo-spacing-16 $qvo-spacing-16;
  margin-bottom: $qvo-spacing-24;
  border-radius: 8px;
  background: $qvo-color-blue-100;
  &::v-deep {
    .config-field {
      margin-bottom: 0;
    }
  }
}
.content-field {
  margin-bottom: $qvo-spacing-24;
}
.has-value {
  border-left: 4px solid $qvo-color-blue-400;
  background: $qvo-color-blue-100;
  &:last-child {
    border-radius: 0 0 8px 8px;
  }
  .question {
    margin-left: -4px;
  }
  .answer {
    margin-left: -2px;
  }
}
</style>